import React from "react";

type ResourceGateProps = {
  // Where the gated asset lives, once it is available for direct download.
  downloadUrl?: string;
  downloadLabel?: string;
};

// Whitepaper access. If a direct download is available we offer it; otherwise
// we point people to the contact page to request an early copy.
function ResourceGate({
  downloadUrl,
  downloadLabel = "Download the whitepaper",
}: ResourceGateProps) {
  if (downloadUrl) {
    return (
      <div className="gate-success">
        <a
          className="cta-button"
          href={downloadUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {downloadLabel}
        </a>
      </div>
    );
  }

  return (
    <div className="gate-fallback">
      <p className="cta-note">
        The whitepaper is on its way. Reach out and we'll send you an early copy.
      </p>
      <a className="cta-button" href="/contact">
        Request the whitepaper
      </a>
    </div>
  );
}

export default ResourceGate;
